import { atom as stateSegment } from 'jotai';
import { NotificationsResponseData } from '../../../types/Content';

export const notificationsAtom = stateSegment<NotificationsResponseData[]>([]);

notificationsAtom.debugLabel = 'notificationsSegment';
